<template>
 <div>
   <div  ref="searchBox">
     <div class="detailsTitle">
        <h4>控货查询</h4>
    </div>
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class=" inpBox">
          <el-form-item label="客户名称:" prop="customerTaxId">
                <el-select  v-model="searchFrom.customerTaxId"  placeholder="请选择">
                  <el-option v-for="val in customerList" :label="val.secondaryCustomerName" :value="val.secondaryCustomerId" :key="val.secondaryCustomerId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:" class="jiage" prop="productType">
                <el-select  v-model="searchFrom.productType"   placeholder="请选择">
                  <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货权方:" prop="ownerCustomerName">
                <el-input  placeholder="" v-model="searchFrom.ownerCustomerName"></el-input>
              </el-form-item>
               <el-form-item label="产地:" prop="steelMillName">
                <el-input  placeholder="" v-model="searchFrom.steelMillName"></el-input>
              </el-form-item>
               <el-form-item label="材质:" prop="model">
                <el-input  placeholder="" v-model="searchFrom.model"></el-input>
              </el-form-item>
               <el-form-item label="规格:" prop="specification">
                <el-input  placeholder="" v-model="searchFrom.specification"></el-input>
              </el-form-item>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总件数：<span class="red">{{tongji.totalNumber}}</span>件</p>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总重量：<span class="red">{{tongji.totalAllWeight}}</span>吨</p>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="ownerCustomerName"  min-width="200" :formatter="emptyFn" label="货权方"></el-table-column>
        <el-table-column prop="customerName"  min-width="200" :formatter="emptyFn" label="客户名称"></el-table-column>
        <el-table-column property="productTypeName"  width="100" label="货物类型"></el-table-column>
        <el-table-column property="steelMillName" width="200"  label="产地"></el-table-column>
        <el-table-column property="specification" width="100"  label="规格"></el-table-column>
        <el-table-column property="model" width="120" label="材质"></el-table-column>
        <el-table-column property="number" width="120" :formatter="emptyFn"  label="总件数"></el-table-column>
        <el-table-column property="singletonWeight" width="130"   label="单件理重(吨)"></el-table-column>
        <el-table-column property="allWeight" width="130"   label="总重量(吨)"></el-table-column>
        <el-table-column property="weight" width="130"   label="总理重(吨)"></el-table-column>
        <el-table-column property="stockPoundWeight" min-width="130"    label="总磅重(吨)"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { getDictionaryAll, getStockCustomerList, getStockCustomerListWn, getTEmptyCargoControlList, getOrganizationNameList } from '@/api/soc-stock-cosco'
export default {
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        organizationId: localStorage.getItem('createTenantCode'),
        primaryCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber')
      },
      total: 0,
      tongji: {},
      loading: 'false',
      productTypes: [],
      warehouseList: [],
      customerList: []
    }
  },
  created () {
    getDictionaryAll({ groupNo: 'thread_product_type' }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ show_name: '全部', item_no: '' })
    })
    // this.getList(this.searchFrom)
    if (localStorage.getItem('isCutCrm3') == 1) {
      getTEmptyCargoControlList({
        primaryCustomerTaxId: this.searchFrom.primaryCustomerTaxId,
        organizationId: this.searchFrom.organizationId
      }).then(res => {
        this.customerList = JSON.parse(res)
      })
      this.getList(this.searchFrom)
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseList = res
        if (res.length > 0) {
          getTEmptyCargoControlList({
            primaryCustomerTaxId: this.searchFrom.primaryCustomerTaxId,
            organizationId: res[0].relTenantCode
          }).then(res => {
            this.customerList = JSON.parse(res)
          })
        }
        this.getList(this.searchFrom)
      })
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      getStockCustomerList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      getStockCustomerListWn(searchFrom).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        organizationId: localStorage.getItem('createTenantCode'),
        primaryCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber')
      }
      this.searchFn()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.searchBox /deep/.el-form-item{
  display: flex;
}
</style>
